import { useNavigation, useRoute, useRouter } from 'expo-router';
import { StyleSheet } from 'react-native-unistyles';
import Button from '@/components/UI/Button';
import Icon from '@/components/Unistyles/Icon';

const isAndroid = process.env.EXPO_OS === 'android';

export default function useHeaderBackButton(
  onPress?: () => void,
  icon?: 'arrow-back-outline' | 'close-outline',
) {
  const navigation = useNavigation();
  const route = useRoute();
  const { back } = useRouter();
  const onPressHeaderBack = onPress ?? back;
  const hasPreviousScreen =
    (navigation
      .getState()
      ?.routes.findIndex((screen) => screen.key === route.key) ?? 0) > 0;
  const resolvedIcon =
    icon ?? (hasPreviousScreen ? 'arrow-back-outline' : 'close-outline');

  return () => (
    <Button
      accessibilityLabel={resolvedIcon === 'close-outline' ? 'Close' : 'Back'}
      appearance="ghost"
      style={style.button(isAndroid)}
      onPress={onPressHeaderBack}
      hitSlop={20}
      iconOnly
    >
      <Icon name={resolvedIcon} size="3xl" />
    </Button>
  );
}

const style = StyleSheet.create((theme) => ({
  button: (isAndroid: boolean) => ({
    width: theme.size(10),
    height: theme.size(10),
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: theme.borderRadius.full,
    marginRight: isAndroid ? theme.size(6) : theme.size(0),
    _web: {
      marginLeft: theme.size(2),
      marginRight: theme.size(1),
    },
  }),
}));
